module.exports = __webpack_public_path__ + "img/sheet.f57e53e6.png";